import { render, staticRenderFns } from "./ProfileEl.vue?vue&type=template&id=31c9621c&scoped=true&"
import script from "./ProfileEl.vue?vue&type=script&lang=ts&"
export * from "./ProfileEl.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileEl.vue?vue&type=style&index=0&id=31c9621c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c9621c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
